import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Chargepoint } from '../../../api/chargepoints-api.service';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';
import { LastHeartbeatInfoComponent } from '../last-heartbeat-info/last-heartbeat-info.component';
import { OcppVendorInfoComponent } from '../ocpp/ocpp-vendor-info/ocpp-vendor-info.component';
import { OkechargeVendorInfoComponent } from '../okecharge/okecharge-vendor-info/okecharge-vendor-info.component';
import { IvyVendorInfoComponent } from '../ivy/ivy-vendor-info/ivy-vendor-info.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ChargepointConfigurationDialogComponent } from '../../chargepoint-configuration/chargepoint-configuration-dialog/chargepoint-configuration-dialog.component';
import { ChargepointStatusComponent } from '../chargepoint-status/chargepoint-status.component';
import { ChargepointTracesDialogComponent } from '../../chargepoint-traces/chargepoint-traces-dialog/chargepoint-traces-dialog.component';
@Component({
  selector: 'app-chargepoint-card',
  templateUrl: './chargepoint-card.component.html',
  styleUrls: ['./chargepoint-card.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    LastHeartbeatInfoComponent,
    OcppVendorInfoComponent,
    OkechargeVendorInfoComponent,
    IvyVendorInfoComponent,
    MatDialogModule,
    ChargepointStatusComponent
  ]
})
export class ChargepointCardComponent {

  @Input() chargepoint?: Chargepoint;
  @Input() hideActions: boolean = false;

  @Output() goToChargepointClick = new EventEmitter<void>();

  public getChargepointName(): string {
    if (this.chargepoint?.type === 'IVY') {
      return (this.chargepoint as { plugId?: string }).plugId || this.chargepoint.id || 'Unnamed Chargepoint';
    }
    return this.chargepoint?.id || 'Unnamed Chargepoint';
  }

  constructor(private dialog: MatDialog) { }
  public showChangeConfigurationDialog() {
    this.dialog.open(ChargepointConfigurationDialogComponent, {
      data: { chargepoint: this.chargepoint },
      width: '650px',
      maxWidth: '650px'
    });
  }

  public showLogsDialog() {
    this.dialog.open(ChargepointTracesDialogComponent, {
      data: { chargepoint: this.chargepoint },
      width: '850px',
      maxWidth: '850px'
    });
  }
}
